import { useContext } from "react";

import { ReferralsContext } from "./ReferralsContext";

export const useReferralsContext = () => {
  const context = useContext(ReferralsContext);

  if (context === undefined) {
    throw new Error("useReferralsContext must be used within a ReferralsContext");
  }

  return context;
};
